<template>
    <b-modal ref="modal" centered hide-header  no-close-on-backdrop no-close-on-esc hide-footer size="lg">
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('OBJECTDETAILS')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group"  v-if="formData != null">
                <div class="form-row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('NAME')">
                            <inputvalidation :formerror="formError" name="name">
                            <b-form-input type="text" v-model="formData.name"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
          </div>
          </div>
            <div class="text-center mt-lg mb-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/building_detail/ObjectDetails.js';


export default
{
    name: 'ObjectDetailsForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            formError: {},        
            formData: null,
        };
    },
    methods:
    {
        async submitData(item)
      {
          const me = this;
            try
            {
                if (typeof item.objectDetailsId !== 'undefined')
                {
                    item.id = item.objectDetailsId;
                    delete (item.objectDetailsId);
                }

                const val = await Api.save(item);

                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.close();
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
      },
        close()
        {
            const me = this;
            me.newuser = false;
            me.formData = null;
            me.formError = {};
            me.userSubCompanies = {};
            me.userCompanies = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
